import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Center from "layouts/wrapper/Center";
import { clone, getLocalStorage } from "shared/utils/Utils";
import style from "./SearchBar.module.css";
import initialSearchCondition from "InitialData/InitialSearchCondition.json";
import { useNavigate } from "react-router-dom";

const { forwardRef, useImperativeHandle, useRef } = require("react");

const SearchBar = forwardRef((props, ref) => {
    const navigate = useNavigate();
    const input = useRef();
    const { width, height, color, borderSize, borderRadius } = props;

    const onKeyUp = (e) => {
        // Enter 키 입력 시 검색
        if (e.key === "Enter") {
            onSearchClick();
        }
    };

    const onSearchClick = () => {
        const keyword = input.current.value.trim();
        // 부모로부터 넘겨받은 onSearch(props.onSearch) 호출
        if (props.onSearch && keyword) {
            props.onSearch(keyword);
        }
    };

    useImperativeHandle(ref, () => ({
        getValue() {
            // return value;
        },
        setValue(value) {
            // setValue(value);
        },
        isValid() {
            // return isValid;
        },
        focus() {
        }
    }));

    return (
        <div className={style.wrap}>
            <HorizontalFlex>
                <FlexChild>
                    <input ref={input} className={style.input} type="text" onKeyUp={onKeyUp} placeholder="주문한 상품을 검색할 수 있어요" />
                </FlexChild>
                <FlexChild width={50}>
                    <div className={style.icon} onClick={onSearchClick}>
                        <Center>
                            <FontAwesomeIcon icon={fas["faSearch"]} />
                        </Center>
                    </div>
                </FlexChild>
            </HorizontalFlex>
        </div>
    );
});

export default SearchBar;